import { memo } from 'react';
import { useSelector } from 'react-redux';

import { UploadIcon } from '@air/design-icons';
import { contentCollectionFormSelector } from '@air/feature-content-collection/redux';
import { ContentCollectionCompletedUploads } from '@air/feature-content-collection/ui';

import { ContentCollectionUploadMoreButton } from '~/components/ContentCollection/ContentCollectionUploadMoreButton';

export const ContentCollectionCompletedView = memo(() => {
  const form = useSelector(contentCollectionFormSelector);

  return (
    <div
      data-testid="CONTENT_COLLECTION_COMPLETED_VIEW"
      className="flex size-full flex-col items-center justify-center gap-4 overflow-y-auto p-4"
    >
      <div className="flex flex-col gap-1 text-center">
        <h1 className="font-semibold ads:text-primary text-24 text-gray-12">Thank you for submitting!</h1>
        <p className="ads:text-metadata text-16 text-gray-10">Your files have been shared with {form.workspace.name}</p>
      </div>
      <ContentCollectionCompletedUploads />
      <ContentCollectionUploadMoreButton prefix={<UploadIcon size="sm" />} size="medium">
        Upload again
      </ContentCollectionUploadMoreButton>
    </div>
  );
});

ContentCollectionCompletedView.displayName = 'ContentCollectionCompletedView';
